import React from 'react';
import { SigninCover } from 'ui';

const SigninCoverPage = (): JSX.Element => {
  return <SigninCover />;
};

export default SigninCoverPage;
